import React from 'react';
import { uspItems } from '../../data/mock';
import { Palette, Heart, CheckCircle, Leaf } from 'lucide-react';

const iconMap = {
  Palette: Palette,
  Heart: Heart,
  CheckCircle: CheckCircle,
  Leaf: Leaf,
};

const USPSection = () => {
  return (
    <section id="miert-mi" className="py-24 bg-cream-white">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="font-montserrat text-sm uppercase tracking-[0.2em] text-warm-sage mb-4">
            Miért minket válassz?
          </p>
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal">
            A NekedSzedtem különlegessége
          </h2>
        </div>

        {/* USP Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {uspItems.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group bg-white rounded-lg p-8 text-center shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-soft-taupe/30 mb-6 group-hover:bg-warm-sage/20 transition-colors duration-300">
                  <IconComponent className="w-7 h-7 text-warm-sage" />
                </div>

                {/* Title */}
                <h3 className="font-playfair text-xl text-charcoal mb-3">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="font-montserrat text-sm text-warm-gray leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default USPSection;
